// extracted by mini-css-extract-plugin
export default {"title":"styles_title__84R+s","customButton":"styles_customButton__a4dKO","activeButton":"styles_activeButton__1Ecpt"};